<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>弹出消息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <create-notice @refresh="refreshList"></create-notice>
        <el-input
          placeholder="请输入搜索内容"
          v-model="query"
          clearable
          @keyup.enter.native="handleSearch()"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <el-table :data="noticeList">
        <el-table-column label="标题" prop="title[1]"></el-table-column>
        <el-table-column label="链接" prop="url"></el-table-column>
        <el-table-column label="展示">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.enabled"
              active-color="#13ce66"
              @change="handleEnable(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleUpdate(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlePageChanged"
      ></pagination>
    </el-card>
    <update-notice @refresh="refreshList"></update-notice>
  </div>
</template>

<script>
import './store';
import CreateNotice from './components/create';
import updateNotice from './components/update';
import Pagination from 'components/pagination';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { PAGINATION } from 'common/config';

export default {
  name: 'Notice',
  data() {
    return {
      query: ''
    };
  },
  components: {
    CreateNotice,
    updateNotice,
    Pagination
  },
  methods: {
    ...mapActions('notice', ['list', 'remove', 'enable', 'disable']),
    ...mapMutations('notice', [
      'setNoticeDetailDialogVisible',
      'setNoticeDetail'
    ]),
    handleUpdate(selected) {
      this.setNoticeDetail(selected);
      this.setNoticeDetailDialogVisible(true);
    },
    handleRemove(selected) {
      this.$confirm('确定删除该消息吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(selected.id).then(() => {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.refreshList({ page: 1 });
    },
    refreshList(data = {}) {
      this.list({
        query: this.query,
        ...this.pagination,
        ...data
      });
    },
    handlePageChanged(pagination) {
      this.refreshList(pagination);
    },
    handleEnable(notice) {
      const message = `确定要${notice.enabled ? '禁用' : '启用'}该消息吗？`;
      const action = notice.enabled ? this.disable : this.enable;

     this.$confirm (message, '提示', {
        type: 'warning'
      })
        .then(() => {
          action(notice.id).then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            this.refreshList();
          });
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapState('notice', ['totalCount', 'pagination', 'noticeList'])
  },
  created() {
    this.list({
      query: this.query,
      ...PAGINATION
    });
  }
};
</script>

<style lang="less" scoped></style>
